import React from 'react';
import { cloneWithLanguageCode } from '../utils';

export const Main = ({ children, languageCode, toggleHiddenBuy, toggleHiddenGift, toggleHiddenRequestTransfer, settings }) => (
  <section className="main">
    {children.map(child => React.cloneElement(child, { languageCode, toggleHiddenBuy, toggleHiddenGift, toggleHiddenRequestTransfer, settings }))}
  </section>
);
